import axios from 'axios';
import ApiService from './service/ApiService';

const SendAvviso = async (idReso, idDestinatario, action, onSuccess, onError) => {

    const user              = JSON.parse(sessionStorage.getItem("user"));
    const token             = user?.token;
    const idCliente         = user?.idCliente;
    const idResoDaInviare   = idReso;
    const idMittenteSAT     = user?.id;
    const ragioneSociale    = user?.ragioneSociale;
    const message           = `Richiesta aggiornamento per il reso ${idReso} da parte di ${ragioneSociale}`;


    const headers = {
        Authorization: `Bearer ${token}`,
    };

    const now       = new Date();
    const day       = String(now.getDate()).padStart(2, '0');
    const month     = String(now.getMonth() + 1).padStart(2, '0'); // Perché i mesi in JavaScript vanno da 0 a 11
    const year      = now.getFullYear();
    const hours     = String(now.getHours()).padStart(2, '0');
    const minutes   = String(now.getMinutes()).padStart(2, '0');

    let datiAvviso = {};

    switch (action) {
        case 'AVVISO':
            datiAvviso = {
                tipo: 0, // 0 per gli avvisi, 1 per la chat
                idMittente: idCliente,
                idDestinatario: idDestinatario,
                testo: `Richiesta aggiornamento per il reso ${idResoDaInviare} da parte di ${ragioneSociale}`,
                idReso: idResoDaInviare,
                data: `${day}/${month}/${year} ${hours}:${minutes}`,
            };
            break;

        case 'AVVISO_SAT':
            datiAvviso = {
                tipo: 0,
                idMittente: idMittenteSAT,
                idDestinatario: idDestinatario,
                testo: `Richiesta aggiornamento per il reso ${idResoDaInviare} da parte del SAT`,
                idReso: idResoDaInviare,
                data: `${day}/${month}/${year} ${hours}:${minutes}`,
            };
            break;

        case 'AVVISO_MODIFICA_SAT':
            datiAvviso = {
                tipo: 0,
                idMittente: idMittenteSAT,
                idDestinatario: idDestinatario,
                testo: `Aggiornamento stato reso #${idResoDaInviare}`,
                idReso: idResoDaInviare,
                data: `${day}/${month}/${year} ${hours}:${minutes}`,
            };
            break;

        case 'AVVISO_RIFIUTO':
            datiAvviso = {
                tipo: 0,
                idMittente: idMittenteSAT,
                idDestinatario: idDestinatario,
                testo: `La richiesta RMA #${idResoDaInviare} è stata rifiutata.`,
                idReso: idResoDaInviare,
                data: `${day}/${month}/${year} ${hours}:${minutes}`,
            };
            break;

        case 'AVVISO_ACCETTATO_INVIO':
            datiAvviso = {
                tipo: 0,
                idMittente: idMittenteSAT,
                idDestinatario: idDestinatario,
                testo: `La richiesta RMA #${idResoDaInviare} è stata accettata. Il cliente deve inviare la merce.`,
                idReso: idResoDaInviare,
                data: `${day}/${month}/${year} ${hours}:${minutes}`,
            };
            break;

        case 'AVVISO_ACCETTATO_RITIRO':
            datiAvviso = {
                tipo: 0,
                idMittente: idMittenteSAT,
                idDestinatario: idDestinatario,
                testo: `La richiesta RMA #${idResoDaInviare} è stata accettata. Il SAT provvederà al ritiro della merce.`,
                idReso: idResoDaInviare,
                data: `${day}/${month}/${year} ${hours}:${minutes}`,
            };
            break;

        case 'MESSAGGIO_SAT':
            datiAvviso = {
                tipo: 0,
                idMittente: idMittenteSAT,
                idDestinatario: idDestinatario,
                testo: `Nuovo messaggio in chat per reso #${idResoDaInviare}`,
                idReso: idResoDaInviare,
                data: `${day}/${month}/${year} ${hours}:${minutes}`,
            };
            break;

        case 'NUOVA_RMA':
            datiAvviso = {
                tipo: 0,
                idMittente: idMittenteSAT,
                idDestinatario: idDestinatario,
                testo: `Nuovo RMA #${idResoDaInviare} creata da ${ragioneSociale}`,
                idReso: idResoDaInviare,
                data: `${day}/${month}/${year} ${hours}:${minutes}`,
            };
            break;

        case 'INTEGRAZIONE_RMA':
            datiAvviso = {
                tipo: 0,
                idMittente: idMittenteSAT,
                idDestinatario: idDestinatario,
                testo: `Richiesta integrazione RMA #${idResoDaInviare}`,
                idReso: idResoDaInviare,
                data: `${day}/${month}/${year} ${hours}:${minutes}`,
            };
            break;

        default:
            console.error('Azione non riconosciuta.');
            return;
    }


    // const urlMessaggio = "http://localhost:8080/messaggio/salva";

    try {
        // const responseAvviso = await axios.post(urlMessaggio, datiAvviso, { headers: headers });
        const responseAvviso = await ApiService.request("saveMessage", datiAvviso);
        if (onSuccess) onSuccess();
    } catch (error) {
        console.error('Errore nell\'invio dell\'avviso', error.response ? error.responseAvviso.data : error.message);
        if (onError) onError();
    }
};

export default SendAvviso;